module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="row">\n	<div class="col-6">\n		<div id="headline-region"></div>\n	</div>\n	<div class="col-6 go-back-crumb">\n		<a href="/#bills">Return to bills overview</a>\n	</div>\n	<div id="bill-list-region" class="col-12"></div>\n</div>';
}
return __p;
};
